module.exports = __webpack_public_path__ + "static/media/portal-enter.e2028c4c.svg";